import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RoutesContainer from "./RoutesContainer";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RoutesContainer />
  </React.StrictMode>
);
